import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const InterviewerRsvpGoingIcon = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...props}>
      <path
        d="M2.0547 12.8978C1.39015 13.3408 0.5 12.8644 0.5 12.0657V3C0.5 1.61929 1.61929 0.5 3 0.5H11C12.3807 0.5 13.5 1.61929 13.5 3V9C13.5 10.3807 12.3807 11.5 11 11.5H4.90833C4.41476 11.5 3.93225 11.6461 3.52158 11.9199L2.0547 12.8978Z"
        fill="white"
        stroke="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.77735 12.4818C1.44507 12.7033 1 12.4651 1 12.0657V3C1 1.89543 1.89543 1 3 1H11C12.1046 1 13 1.89543 13 3V9C13 10.1046 12.1046 11 11 11H4.90833C4.31605 11 3.73703 11.1753 3.24423 11.5038L1.77735 12.4818ZM10.5511 4.50871C10.8321 4.20434 10.8131 3.72985 10.5087 3.4489C10.2043 3.16794 9.72985 3.18692 9.4489 3.49129L6.27616 6.92843L4.52023 5.23754C4.22186 4.95022 3.74708 4.95918 3.45976 5.25755C3.17244 5.55591 3.1814 6.0307 3.47977 6.31802L5.78746 8.54024C5.93272 8.68012 6.12819 8.75561 6.32976 8.74968C6.53133 8.74374 6.72201 8.65689 6.8588 8.50871L10.5511 4.50871Z"
        fill="#00A39E"
      />
    </SvgIcon>
  );
};
